module.exports = __webpack_public_path__ + "img/logo_2.69fe30bd.svg";